export const ON_CHANGE_REQUEST_FIELDS = '@relatoriosAS/ON_CHANGE_REQUEST_FIELDS';
export const ON_UPDATE_REQUEST_FIELDS = '@relatoriosAS/ON_UPDATE_REQUEST_FIELDS';
export const SET_STORE_VALUE = '@relatoriosAS/SET_STORE_VALUE';
export const ON_FOCUS_REQUEST_FIELDS = '@relatoriosAS/ON_FOCUS_REQUEST_FIELDS';
export const GERAR_RELATORIO_AS = '@relatoriosAS/GERAR_RELATORIO_AS';
export const SET_SNACKBAR_RELATORIO = '@relatoriosAS/SET_SNACKBAR_RELATORIO';
export const RESET_SCREEN = '@relatoriosAS/RESET_SCREEN';
